// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3I_4Y","Open":"SideDrawer_Open__142ME","Close":"SideDrawer_Close__1hQrE","Logo":"SideDrawer_Logo__3A1Rp"};